<template>
    <b-modal size="xl" button-size="sm" hide-footer v-model="showModal" :title="prefix + title" @hidden="cancelar">
        <Lg-finder-page-pessoa-modal @onSelect="addAlmoxarife" ref="finderPessoa"
            :prefix="prefix + title + ' > '"></Lg-finder-page-pessoa-modal>

        <b-card no-body>
            <b-card-body>
                <b-card bg-variant="light">
                    <b-form-row>
                        <lg-form-input invalidFeedback="Descrição deve ser informada!" description=""
                            :error="$v.form.descricao" v-model="form.descricao" label="Descrição:" lg="10" sm="6"
                            md="10" />

                        <lg-form-input v-if="id != null" invalidFeedback="" description="" :disabled="true"
                            v-model="form.situacaoDesc" label="Status*:" lg="3" sm="3" md="3" />

                    </b-form-row>
                    <div class="d-flex justify-content-end">

                        <b-button id="adicionar" class="ml-3 mr-4" size="sm" style="height: 60px" pill variant="primary"
                            @click="addAlmoxarifeIntent">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="plus" />
                            </div>
                            <b-tooltip target="adicionar" title="Adicionar novo responsável..."></b-tooltip>

                        </b-button>
                    </div>
                    <b-table :busy="busy" id="t-pessoas" responsive="sm" stacked="sm" small outlined sticky-header
                        show-empty head-variant="light" :items="form.almoxarifes" :fields="almoxarifesFields">
                        <template #empty>
                            <h6 style="text-align: center">Nenhum almoxarife vinculado</h6>
                        </template>

                        <template #table-busy>
                            <div class="text-center text-primary my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong> Carregando...</strong>
                            </div>
                        </template>

                        <template #head()="data">
                            <h6>{{ data.label.toUpperCase() }}</h6>
                        </template>
                        <template v-slot:cell(action)="row">
                            <b-button :id="row.index + 'excluirAlmoxarife'" class=" my-2" size="sm" pill
                                variant="primary" @click="removeAlmoxarife(row.item)">
                                <b-icon icon="trash-fill" />
                                <b-tooltip :target="row.index + 'excluirAlmoxarife'" title="Remover..."></b-tooltip>

                            </b-button>
                        </template>
                    </b-table>

                    <b-form-row>

                        <b-col cols="3"></b-col>
                        <b-col cols="6" class="text-center">
                            <b-button id="salvar" class=" my-2" size="sm" pill variant="success" @click="save">
                                <b-icon icon="check-circle" />
                                <b-tooltip target="salvar" title="Salvar"></b-tooltip>

                            </b-button>

                            <b-button id="cancelar" class=" my-2 ml-2" size="sm" pill variant="danger"
                                @click="cancelar">
                                <b-icon icon="x-circle" />
                                <b-tooltip target="cancelar" title="Cancelar"></b-tooltip>

                            </b-button>
                        </b-col>
                        <b-col cols="3"></b-col>

                    </b-form-row>

                </b-card>
            </b-card-body>
        </b-card>
    </b-modal>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import ResourceService from "@/core/api/ResourceService";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import ConfirmMixin from "@/core/mixins/confirm";
import { FormResourceMixin } from "@/core/mixins/resource";
import LgFinderPagePessoaModal from "@/components/Modal/LgFinderPagePessoaModal.vue";

export default {
    components: {
        LgFormInput,
        LgFinderPagePessoaModal,
    },
    mixins: [ConfirmMixin, FormResourceMixin],

    props: {
        id: Number,
        ignoreInitialLoad: Boolean,
        prefix: {
            type: String,
            default: "",
        },
        salvar: Function,
    },
    data() {
        return {
            title: " Cadastro",
            showModal: true,
            form: {
                id: null,
                almoxarifes: [],
                descricao: "",
                situacao: 1,
            },
            options: [
                { text: "Ativo", value: 1 },
                { text: "Inativo", value: 0 },
            ],
            busy: false,
            tabIndex: 0,
        };
    },
    async beforeMount() {
        this.$service = new ResourceService(
            `/api/almoxarifados`
        );
        if (this.id) {
            this.busy = true;
            const { data } = await this.$service.findById(this.id);
            data.situacaoDesc = data.situacao == 1 ? 'ATIVO' : 'INATIVO';
            this.busy = false;
            this.form = data;
        }
    },
    validations: {
        form: {
            descricao: {
                required,
            },
        },
    },

    computed: {
        formIsValid() {
            return !this.$v.$invalid;
        },
        almoxarifesFields() {
            return [
                {
                    key: "id",
                    label: "Código",
                    tdClass: "py-0 col-2 d-none",
                    thClass: "d-none",
                },
                { key: "nome", label: "Pessoas", tdClass: "py-0 col-2" },
                { key: "action", label: " ", tdClass: "w-1" },
            ];
        },
    },
    methods: {
        async addAlmoxarifeIntent() {
            this.$refs.finderPessoa.show();
        },
        async addAlmoxarife(almoxarife) {
            this.$refs.finderPessoa.showModal = false;
            const found = this.form.almoxarifes.find(
                item => item.id === almoxarife.id
            );

            if (found) {
                this.$notify({
                    type: "danger",
                    message: "Almoxarife já vinculado!",
                });
                return;
            }

            this.form.almoxarifes.push({
                id: almoxarife.id,
                nome: almoxarife.nome,
            });
        },
        cancelar() {
            this.$emit("close");
        },

        async removeAlmoxarife(almoxarife) {

            let response = await this.$confirm(
                "Confirmação",
                "Tem certeza que deseja remover a vinculação?"
            );

            if (response) {
                this.form.almoxarifes.splice(
                    this.form.almoxarifes.indexOf(almoxarife),
                    1
                );
            }
        },
        async save() {
            if (!this.formIsValid) {
                this.$v.$touch();
                this.$notify({
                    type: "danger",
                    message: "Verifique os campos do cadastro.",
                });
                return;
            }
            try {

                this.busy = true;
                await this.$saveResource(this.form);
                this.$emit("close");
            } catch (e) {
                this.busy = false;
                this.$notify({
                    type: "danger",
                    message: "Ocorreu um erro ao salvar o cadastro.",
                });
            }
        },
        resetForm() {
            this.almoxarifado = {
                almoxarifes: [],
                descricao: "",
                situacao: null,
            };
        },
    },
};
</script>
